import React from "react";
import {useHistory} from "react-router-dom";
import {PAGE_URLS} from "constants/AppConstants.js";
import {ws} from "styles/tokens";
import BrowserService from "services/BrowserService.js";
import ProfileImageModal from "components/Common/ProfileImageModal";
import {StyleDiv} from "components/Common/StyleDiv";
import {StyleImg} from "components/Common/StyleImg";
import {StyleLink} from "components/Common/StyleLink";

const ProfileImageModalAny: any = ProfileImageModal;

export const ADMIN_NAV_HEIGHT = "70px";

interface AdminNavProps {
  selectedUser: any;
  setSelectedUser: (user: any) => void;
}

function AdminNav({selectedUser, setSelectedUser}: AdminNavProps) {
  const history = useHistory();

  return (
    <StyleDiv
      position="sticky"
      top="0"
      zIndex="90000"
      height={ADMIN_NAV_HEIGHT}
      padding="8px 16px 4px"
      backgroundColor={ws.wash}
    >
      <StyleDiv
        className="ws-nav app-nav"
        height="100%"
        justifyContent="space-between"
        padding="0px 8px 0px 20px"
        boxShadow={ws.shadowSoft}
        gap="8px"
      >
        <StyleDiv
          display="flex"
          alignItems="center"
          cursor="pointer"
          className="d-none d-md-flex"
          onClick={() => {
            history.push(PAGE_URLS.adminPageUrl);
          }}
        >
          <StyleImg className="ws-logo" height="20px" src="/assets/images/waterspeed-logo.svg" alt="Waterspeed" />
        </StyleDiv>

        <nav className="ws-menu app-nav-menu" style={{alignItems: "center"}}>
          <AdminNavItem href={PAGE_URLS.adminPageUrl} text="Dashboard" click={() => setSelectedUser(null)} />
          <AdminNavItem href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.redeemCode}`} text="Redeem Code" />
          <AdminNavItem href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.challengesPageUrl}`} text="Challenges" />
          <AdminNavItem
            href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.adminActivitiesPageUrl}`}
            text="Activities"
            click={() => setSelectedUser(null)}
          />
          <AdminNavItem
            href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.autoTrimPageUrl}`}
            text="Auto trim"
            click={() => setSelectedUser(null)}
          />
          <AdminNavItem
            href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.equipmentsPageUrl}`}
            text="Equipments"
            click={() => setSelectedUser(null)}
          />
          <AdminNavItem
            href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.usersPageUrl}`}
            text="Users"
            click={() => setSelectedUser(null)}
          />
          <AdminNavItem
            href={`${PAGE_URLS.adminPageUrl}${PAGE_URLS.localExpertsPageUrl}`}
            text="Local Experts"
            click={() => setSelectedUser(null)}
          />
          {selectedUser && (
            <StyleDiv
              display="flex"
              alignItems="center"
              gap="2px"
              padding="0 4px"
              marginLeft="6px"
              borderRadius={ws.radiusPill}
              border={`1px solid ${ws.line}`}
            >
              <AdminNavItem
                href={`${PAGE_URLS.adminPageUrl}/${selectedUser.uid}${PAGE_URLS.diaryPageUrl}`}
                text="Activities"
              />
              <AdminNavItem
                href={`${PAGE_URLS.adminPageUrl}/${selectedUser.uid}${PAGE_URLS.logsPageUrl}`}
                text="Logs"
              />
            </StyleDiv>
          )}
        </nav>
        <StyleDiv display="flex" flexDirection="row" alignItems="center" gap="6px">
          <AdminNavItem href={`${PAGE_URLS.diaryPageUrl}`} text="User portal" click={() => setSelectedUser(null)} />
          <ProfileImageModalAny zIndex="90000" />
        </StyleDiv>
      </StyleDiv>
    </StyleDiv>
  );
}

interface AdminNavItemProps {
  text: string;
  href: string;
  click?: () => void;
}

function AdminNavItem({text, href, click}: AdminNavItemProps) {
  const currentUrlPath = BrowserService.getPathname();
  const isHrefIsCurrentPathName = currentUrlPath === href;

  return (
    <StyleLink
      to={href}
      className="ws-nl"
      onClick={() => click?.()}
      aria-current={isHrefIsCurrentPathName ? "page" : undefined}
      color={isHrefIsCurrentPathName ? ws.accentText : ws.fg}
      style={{
        whiteSpace: "nowrap",
        fontWeight: isHrefIsCurrentPathName ? 600 : 500,
        background: isHrefIsCurrentPathName ? ws.hover : undefined
      }}
    >
      {text}
    </StyleLink>
  );
}

export default AdminNav;
